import { createSelector } from 'reselect';
import MeetingItemsConstants from 'Shared/constants/MeetingItems.constants';
import MeetingItemHelpers from 'Shared/model_helpers/MeetingItem.helper';
import { ItemType } from 'Shared/types/MeetingItem.type';

// TODO (josh) : this key should come from a constant
const getMeetingItems = State => State.meetingItemsV2;

function createParameterSelector(selector) {
  return (_, params) => selector(params);
}

const getGoalSlugParam = createParameterSelector(params => params.goalSlug);
const getWorkspaceUuidParam = createParameterSelector(params => params.worksapceUuid);
const getParentUuidParam = createParameterSelector(params => params.parentUuid);
const getMeetingItemUuidParam = createParameterSelector(params => params.meetingItemUuid);
const getMeetingItemIdParam = createParameterSelector(params => params.meetingItemId);
const getMeetingItemIdsParam = createParameterSelector(params => params.meetingItemIds);

const getAllMeetingItems = createSelector([getMeetingItems], meetingItems => {
  return meetingItems.get(MeetingItemsConstants.State.MEETING_ITEMS_BY_ITEM_SLUG);
});

export const getDiscussionTopics = createSelector([getAllMeetingItems], meetingItems => {
  return meetingItems.filter(item => MeetingItemHelpers.getItemType(item) === ItemType.discussionTopic);
});

export const getActionItems = createSelector([getAllMeetingItems], meetingItems => {
  return meetingItems.filter(item => MeetingItemHelpers.getItemType(item) === ItemType.actionItem);
});

export const getAllTempMeetingItems = createSelector([getMeetingItems], meetingItems => {
  return meetingItems.get(MeetingItemsConstants.State.TEMP_ACTION_ITEM_IDS_BY_SLUG);
});

const getMeetingItemsIdsByGoalSlug = createSelector([getMeetingItems, getGoalSlugParam], (meetingItems, goalSlug) => {
  return meetingItems.getIn([MeetingItemsConstants.State.ACTION_ITEM_IDS_BY_GOAL_SLUG, goalSlug]) || [];
});

const getMeetingItemsIdsByWorkspaceUuid = createSelector(
  [getMeetingItems, getWorkspaceUuidParam],
  (meetingItems, workspaceUuid) => {
    return meetingItems.getIn([MeetingItemsConstants.State.ACTION_ITEM_IDS_BY_WORKSPACE_SLUG, workspaceUuid]) || [];
  }
);

// TODO (josh): rework this selector to return a single item, not an ordered map of a single item
// export const getMeetingItemByUuid = createSelector(
//   [getAllMeetingItems, getMeetingItemUuidParam],
//   (meetingItems, uuid) => {
//     return meetingItems.get(uuid);
//   }
// );

export const getMeetingItemById = createSelector([getAllMeetingItems, getMeetingItemIdParam], (meetingItems, id) => {
  return meetingItems.find(item => id === MeetingItemHelpers.getId(item));
});

export const getWorkspaceDiscussionTopics = createSelector(
  [getDiscussionTopics, getWorkspaceUuidParam],
  (discussionTopics, workspaceUuid) => {
    return discussionTopics.filter(topic => MeetingItemHelpers.getWorkspaceId(topic) === workspaceUuid);
  }
);

export const getDiscussionTopicsByIdsAndWorkspace = createSelector(
  [getWorkspaceDiscussionTopics, getMeetingItemIdsParam],
  (meetingItems, ids) => {
    return meetingItems.filter(meetingItem => ids.includes(MeetingItemHelpers.getId(meetingItem)));
  }
);

export const getMeetingItemByUuid = createSelector(
  [getAllMeetingItems, getMeetingItemUuidParam],
  (meetingItems, uuid) => {
    return meetingItems.filter(item => MeetingItemHelpers.getUuid(item) === uuid);
  }
);

export const getActionItemsForGoal = createSelector(
  [getAllMeetingItems, getMeetingItemsIdsByGoalSlug],
  (meetingItems, meetingItemIds) => {
    return meetingItems.filter(item => meetingItemIds.includes(MeetingItemHelpers.getUuid(item)));
  }
);

export const getActionItemsForWorkspace = createSelector(
  [getAllMeetingItems, getMeetingItemsIdsByWorkspaceUuid],
  (meetingItems, meetingItemIds) => {
    return meetingItems.filter(item => meetingItemIds.includes(MeetingItemHelpers.getUuid(item)));
  }
);

export const getAssociatedMeetingsItemsByUuid = createSelector(
  [getAllMeetingItems, getMeetingItemUuidParam],
  (meetingItems, meetingItemUuid) => {
    return meetingItems.filter(item => MeetingItemHelpers.getAssociatedMeetingItemUuid(item) === meetingItemUuid);
  }
);

export const getSubMeetingItems = createSelector(
  [getAllMeetingItems, getParentUuidParam],
  (meetingItems, parentUuid) => {
    return meetingItems.filter(item => MeetingItemHelpers.getParentUuid(item) === parentUuid);
  }
);

export const getTempMeetingItem = createSelector(
  [getAllTempMeetingItems, getMeetingItemUuidParam],
  (tempMeetingItems, uuid) => {
    return tempMeetingItems.filter(item => MeetingItemHelpers.getUuid(item) === uuid);
  }
);

export const getTempMeetingItems = createSelector([getAllTempMeetingItems], tempMeetingItems => {
  return tempMeetingItems.filter(item => !MeetingItemHelpers.getParentUuid(item));
});

export const getTempSubMeetingItems = createSelector(
  [getAllTempMeetingItems, getParentUuidParam],
  (tempMeetingItems, parentUuid) => {
    return tempMeetingItems.filter(item => MeetingItemHelpers.getParentUuid(item) === parentUuid);
  }
);
